KMVP.kmcQuoteEditSubmit = {
    bind: function() {
        $(document).on('click', '.js-submit-quote-edit', this.submit.bind(this));
    },
    submit: function() {
        if (KMVP.kmcQuoteEditTemplating.isPageBlocked()) {
            return;
        }
        KMVP.kmcQuoteEditTemplating.blockPage();
        var requestUrl = KMVP.kmcQuoteEditTemplating.getQuoteEditSubmitUrl();
        var quoteId = KMVP.kmcQuoteEditTemplating.getCurrentQuoteId();
        var requestBody = this.composeRequestBody();
        console.log(requestBody);

        if (requestBody) {
            $.ajax({
               url: requestUrl,
               data: JSON.stringify(requestBody),
               type: "POST",
               contentType: 'application/json',
                success: function (data) {
                    KMVP.kmcQuoteEditStorage.undoAllInQuote(quoteId);
                    KMVP.kmcQuoteCommon.showQuoteConfirmation(data);
                },
                complete: function () {
                    KMVP.kmcQuoteEditTemplating.unblockPage();
                },
                error: function (xht, textStatus, ex) {
                    alert("Failed to process quote edit operation");
                }
            });
        }
    },
    composeRequestBody: function() {
        var requestBody = {
            comment: $('.js-kmc-quote-detail-page .js-quote-comment').val(),
            editedEntries: []
        };
        var quoteChanges = KMVP.kmcQuoteEditStorage.getCurrentQuoteEditChanges();
        if (!quoteChanges.length) {
            return null;
        }
        quoteChanges.forEach(function(change) {
            var requestEntry = {
                lineNumber: change.entryLine,
                oldValue: Number(change.oldQuantity),
                newValue: Number(change.newQuantity),
                modificationType: Number(change.newQuantity) ? "QUANTITY_CHANGED" : "DELETED"
            };
            requestBody.editedEntries.push(requestEntry);
        });
        return requestBody;
    }
};

$(document).ready(function() {
    if ($('.js-kmc-quote-detail-page.js-kmc-quote-status-quote').length){
        KMVP.kmcQuoteEditSubmit.bind();
    }
});
